(() => {
  const selector = '[data-zhoumong-auto-swatch]:not([data-zhoumong-auto-swatch-state])';
  let scheduled = false;

  const median = (values) => {
    const sorted = [...values].sort((a, b) => a - b);
    return sorted[Math.floor(sorted.length / 2)] || 0;
  };

  const averagePixel = (pixels) => {
    const total = pixels.length || 1;
    return pixels.reduce(
      (result, pixel) => [result[0] + pixel[0] / total, result[1] + pixel[1] / total, result[2] + pixel[2] / total],
      [0, 0, 0]
    );
  };

  const distance = (first, second) =>
    Math.hypot(first[0] - second[0], first[1] - second[1], first[2] - second[2]);

  const loadImage = (source) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = source;
    });

  const sampleGarmentColor = async (source) => {
    const image = await loadImage(source);
    const size = 160;
    const scale = Math.min(size / image.naturalWidth, size / image.naturalHeight, 1);
    const width = Math.max(1, Math.round(image.naturalWidth * scale));
    const height = Math.max(1, Math.round(image.naturalHeight * scale));
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    const data = context.getImageData(0, 0, width, height).data;
    const pixelAt = (x, y) => {
      const index = (Math.max(0, Math.min(height - 1, y)) * width + Math.max(0, Math.min(width - 1, x))) * 4;
      return [data[index], data[index + 1], data[index + 2], data[index + 3]];
    };
    const background = averagePixel([
      pixelAt(1, 1),
      pixelAt(width - 2, 1),
      pixelAt(1, height - 2),
      pixelAt(width - 2, height - 2),
    ]);
    const samples = [];
    const foreground = [];
    const bands = [
      [0.28, 0.43],
      [0.57, 0.72],
    ];

    for (const [start, end] of bands) {
      for (let y = Math.round(height * 0.42); y < Math.round(height * 0.8); y += 3) {
        for (let x = Math.round(width * start); x < Math.round(width * end); x += 3) {
          const pixel = pixelAt(x, y);
          if (pixel[3] < 230) continue;
          const color = pixel.slice(0, 3);
          samples.push(color);
          if (distance(color, background) > 16) foreground.push(color);
        }
      }
    }

    const colors = foreground.length >= 24 ? foreground : samples;
    if (!colors.length) throw new Error('No fabric pixels were found.');

    return [
      Math.round(median(colors.map((color) => color[0]))),
      Math.round(median(colors.map((color) => color[1]))),
      Math.round(median(colors.map((color) => color[2]))),
    ];
  };

  const processSwatch = async (swatch) => {
    swatch.dataset.zhoumongAutoSwatchState = 'pending';
    const source = swatch.dataset.zhoumongAutoSwatchImage;
    if (!source) {
      swatch.dataset.zhoumongAutoSwatchState = 'fallback';
      return;
    }

    try {
      const [red, green, blue] = await sampleGarmentColor(source);
      swatch.style.setProperty('--swatch-background', `rgb(${red} ${green} ${blue})`);
      swatch.dataset.zhoumongAutoSwatchState = 'ready';
    } catch (error) {
      swatch.dataset.zhoumongAutoSwatchState = 'fallback';
    }
  };

  const processSwatches = () => {
    scheduled = false;
    document.querySelectorAll(selector).forEach((swatch) => processSwatch(swatch));
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(processSwatches);
  };

  schedule();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
